import {
  EventCompetitivenessEnum,
  PlaySessionMatchCompetitivenessEnum,
} from 'types/generated/client';

/**
 * An event group stores its own competitiveness enum, but every badge in the app
 * reads the play-session one. Games listed before the game-type question was
 * dropped keep their badge; newer ones have none.
 */
export const mapCompetitiveness = (
  competitiveness: EventCompetitivenessEnum | null | undefined,
): PlaySessionMatchCompetitivenessEnum | undefined => {
  if (competitiveness === EventCompetitivenessEnum.Competitive) {
    return PlaySessionMatchCompetitivenessEnum.Match;
  }
  if (competitiveness === EventCompetitivenessEnum.Casual) {
    return PlaySessionMatchCompetitivenessEnum.Casual;
  }
  return undefined;
};
